import { avatarColumn, textColumn, type DataTableColumn } from '@odo/shared-ui';
import type { PracticeListItemType } from '../../providers/practices/PracticesListProvider';
import { PracticeActionCell } from './PracticeActionCell';

export type PracticesSortBy = 'name' | 'doctorName';

const TD_PADDING = 'px-6 py-0';

function formatDoctorName(doctorName: string | null): string {
    return `Dr. ${(doctorName || '').trim()}`.trim();
}

export function buildPracticeColumns(): DataTableColumn<PracticeListItemType, PracticesSortBy>[] {
    return [
        avatarColumn<PracticeListItemType, PracticesSortBy>({
            key: 'doctor',
            label: 'DOCTOR',
            width: '40%',
            sortable: true,
            sortKey: 'doctorName',
            headerClassName: 'px-6 whitespace-nowrap',
            cellClassName: TD_PADDING,
            name: (practice) => (practice.doctorName || '').trim() || 'Unknown',
            imageUrl: () => null,
            renderLabel: (practice) => (
                <span className="text-sm font-normal leading-4 tracking-[0.005em] text-gray-800">
                    {formatDoctorName(practice.doctorName)}
                </span>
            )
        }),
        textColumn<PracticeListItemType, PracticesSortBy>({
            key: 'practice',
            label: 'PRACTICE',
            width: '40%',
            sortable: true,
            sortKey: 'name',
            truncate: false,
            fallback: '',
            headerClassName: 'px-6 whitespace-nowrap',
            cellClassName: TD_PADDING,
            value: (practice) => practice.name
        }),
        {
            key: 'action',
            label: 'ACTION',
            width: '20%',
            align: 'right',
            headerClassName: 'px-6 whitespace-nowrap',
            cellClassName: TD_PADDING,
            render: (practice) => <PracticeActionCell practice={practice} />
        }
    ];
}
